<div class="banner d-flex align-items-center">
  <div class="banner__logo mr-3">
    <img src="assets/images/klix_logo.svg">
  </div>
  <div class="banner__text small">
    <span>Payments are secured & encrypted by <a href="#" class="action-color semi-bold">Klix</a></span>
    <br>
    <a href="#" class="action-color semi-bold">Read More</a>
  </div>
</div>
